import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';

// No StrictMode: its double-invoked effects would open the socket, the microphone and the audio
// context twice in development, which is exactly the state this app is used to observe.
const root = document.getElementById('root');
if (!root) throw new Error('index.html is missing the #root element the app mounts into');

createRoot(root).render(<App />);
